import { useAuth } from "@clerk/clerk-react";
import { useCallback } from "react";

/**
 * `useAgent` accepts an async `query` callback. WebSocket browser APIs can't
 * carry an Authorization header, so we pass the Clerk session JWT through a
 * query string param. The worker's auth provider knows to read it.
 */
export function useAgentQueryToken() {
  const { getToken } = useAuth();
  return useCallback(async () => {
    const token = await getToken();
    return { __clerk_token: token ?? null };
  }, [getToken]);
}
